import { Alert, Box, Button, Snackbar, Typography } from "@mui/material";
import Header from "../../components/Header";
import { useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

function NftMintingCustomizationPage() {
  const [formValues, setFormValues] = useState({ buttonId: "" });
  const collectionId = useParams();
  const navigate = useNavigate();
  const [selectedFileName, setSelectedFileName] = useState("Upload HTML File");
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [file, setFile] = useState(null);
  function onHandleformValuesChange(e) {
    const { name, value } = e.target;

    setFormValues((preValues) => {
      return {
        ...preValues,
        [name]: value,
      };
    });
  }
  const handleFileChange = (event) => {
    const data = event.target.files[0];
    setFile(data);

    // Check if a file is selected and if it has an HTML file extension
    if (data && data.type === "text/html") {
      setSelectedFileName(data.name);
      // Here you can perform any additional actions with the selected HTML file if needed.
    } else {
      setAlert(true);
      setAlertMessage("Only HTML file type is allowed");
      setSelectedFileName("Upload HTML File");
    }
  };

  async function onFormSubmit(e) {
    e.preventDefault();
    try {
      if (file) {
        const data = new FormData();

        data.append("htmlFile", file);

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BASE_URL}/api/nft-minting/custom-page?collectionId=${collectionId.id}&buttonId=${formValues.buttonId}`,
          data: data,
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }).then((response) => {
          if (response.data.status) {
            swal({
              title: response.data.message,
              icon: "success",
            });
            setFormValues({ buttonId: "" });
            navigate("/nft-minting/collection-detail/" + collectionId.id);
          }
        });
      } else {
        setAlert(true);
        setAlertMessage("Please upload the HTML file before submitting");
      }
    } catch (error) {
      swal({
        title: "Something Went Wrong!",
        icon: "error",
        button: "OK",
      });
    }
  }

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlert(false);
    setAlertMessage("");
  };

  return (
    <Box m="20px">
      <div style={{ marginBottom: "30px" }}>
        <Header title="Add Custom Page" subtitle="Fill the required field " />
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={alert}
        autoHideDuration={3000}
        onClose={handleSnackBarClose}
      >
        <Alert
          onClose={handleSnackBarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          bgcolor: "white",
          boxShadow: 4,
        }}
      >
        <form onSubmit={onFormSubmit}>
          <Typography className="google-drive-typography-text" mb={"5px"}>
            Please provide the Button ID to mint your NFT
          </Typography>
          <Button
            className="custom-color-button"
            sx={{
              fontSize: "15px",
              width: "50%",
            }}
            variant="contained"
            component="label"
          >
            {selectedFileName}
            <input
              accept="text/html"
              type="file"
              hidden
              onChange={handleFileChange}
            />
          </Button>
          <Typography
            className="google-drive-typography-text"
            mt={"20px"}
            mb={"5px"}
          >
            Please provide the Button ID to mint your NFT
          </Typography>
          <fieldset style={{ width: "50%" }} className="login-form ">
            <label
              htmlFor="buttonId"
              id="buttonIdLabel"
              className="login-form-label"
            >
              Button Id
              <div className="input-div-css-1 input-fullwidth input-div-css-2">
                <div className="input-div-css-3">
                  <input
                    required
                    name="buttonId"
                    aria-labelledby="buttonIdLabel"
                    type="text"
                    className="input-custom-css input-custom-height"
                    id="buttonId"
                    aria-invalid="false"
                    value={formValues.buttonId}
                    onChange={(e) => onHandleformValuesChange(e)}
                  ></input>
                </div>
              </div>
            </label>
          </fieldset>
          <Button
            className="custom-color-button"
            sx={{
              fontSize: "15px",
              marginTop: "10px",
            }}
            type="submit"
            variant="contained"
          >
            Submit
          </Button>
        </form>
      </Box>
    </Box>
  );
}

export default NftMintingCustomizationPage;
